(function () {
  'use strict';
  var KEY = 'bsk_model';
  var AIRPODS = [['Apple AirPods', ['AirPods Pro 3', 'AirPods Pro 2', 'AirPods Pro', 'AirPods 5', 'AirPods 4', 'AirPods 3', 'AirPods 2', 'AirPods 1']]];
  var AMAP = { 'airpods pro 2': 'airpods pro (2nd generation)', 'airpods pro': 'airpods pro (1st generation)', 'airpods 3': 'airpods (3rd generation)', 'airpods 2': 'airpods (2nd generation)', 'airpods 1': 'airpods (1st generation)' };
  function data() { var d = window.BSK_MODELS || { full: [], stride: [], glass: [], avail: {} }; d.airpods = AIRPODS; return d; }
  function getAir() { try { return localStorage.getItem('bsk_airpods') || ''; } catch (e) { return ''; } }
  function setAir(m) { try { localStorage.setItem('bsk_airpods', m); } catch (e) {} }
  function isAirCtx() {
    if (/airpod/i.test(location.pathname)) return true;
    var t = document.querySelector('.product-meta__title');
    return !!(t && /airpod/i.test(t.textContent));
  }
  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function getModel() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function setModel(m) { try { localStorage.setItem(KEY, m); } catch (e) {} }
  function inList(listName, model) { return window.BSKFit ? window.BSKFit(listName || 'full', model) : false; }
  function types(model) { return window.BSKTypes ? window.BSKTypes(model) : ''; }

  var NEW_MODELS = ['iphone 18 pro max', 'iphone 18 pro', 'iphone 17e'];
  var drawer, listEl, searchEl, noteEl;
  var activeList = 'full';
  var activeTarget = null;

  function buildList() {
    var current = activeList === 'airpods' ? getAir() : (activeTarget ? (activeTarget.getAttribute('data-value') || '') : getModel());
    var groups = data()[activeList] || [];
    var html = '';
    groups.forEach(function (g) {
      html += '<li class="bsk-picker__brand" data-brand>' + g[0] + '</li>';
      g[1].forEach(function (m) {
        var sel = norm(m) === norm(current);
        html += '<li><button type="button" class="bsk-picker__item' + (sel ? ' is-selected' : '') + '" data-model="' + m.replace(/"/g, '&quot;') + '">' +
          '<span>' + m + (NEW_MODELS.indexOf(norm(m)) > -1 ? ' <em class="bsk-picker__new">New</em>' : '') + '</span>' + (sel ? '<span class="bsk-picker__tag">Selected</span>' : '') + '</button></li>';
      });
    });
    listEl.innerHTML = html;
    filter(searchEl.value);
    var s = listEl.querySelector('.is-selected');
    if (s) { s.scrollIntoView({ block: 'center' }); }
  }

  function filter(q) {
    q = norm(q);
    var brand = null, brandHasVisible = false;
    var items = listEl.children;
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (li.hasAttribute('data-brand')) {
        if (brand) brand.hidden = !brandHasVisible;
        brand = li; brandHasVisible = false; continue;
      }
      var btn = li.firstChild;
      var show = !q || norm(btn.getAttribute('data-model')).indexOf(q) > -1 || (norm(brand && brand.textContent) + ' ' + norm(btn.getAttribute('data-model'))).indexOf(q) > -1;
      li.hidden = !show;
      if (show) brandHasVisible = true;
    }
    if (brand) brand.hidden = !brandHasVisible;
  }

  function open(listName, target) {
    activeList = listName || 'full';
    activeTarget = target || null;
    noteEl.hidden = !(activeTarget && activeList !== 'full');
    searchEl.value = '';
    buildList();
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('bsk-lock');
    setTimeout(function () { if (window.matchMedia && window.matchMedia('(min-width: 741px)').matches) searchEl.focus(); }, 250);
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('bsk-lock');
    setTimeout(function () { drawer.hidden = true; }, 250);
  }

  function choose(model) {
    if (activeList === 'airpods') { setAir(model); updateTriggers(); syncAirpods(true); close(); return; }
    setModel(model);
    if (activeTarget) applyToProduct(activeTarget, model);
    document.querySelectorAll('[data-bsk-pdp]').forEach(function (el) {
      if (el !== activeTarget) applyToProduct(el, model, true);
    });
    updateTriggers();
    filterGrid();
    syncCaseTypes();
    document.dispatchEvent(new CustomEvent('bsk:model-change', { detail: { model: model } }));
    close();
  }

  function updateTriggers() {
    var m = getModel();
    var air = isAirCtx();
    document.querySelectorAll('[data-bsk-trigger-label]').forEach(function (el) {
      var btn = el.closest('[data-bsk-open]');
      if (air && btn && btn.classList.contains('bsk-trigger')) {
        btn.setAttribute('data-bsk-open', 'airpods');
        el.textContent = getAir() || 'Select your AirPods';
      } else {
        el.textContent = m || 'Select your phone';
      }
    });
    document.querySelectorAll('[data-bsk-ch-title]').forEach(function (el) {
      var base = el.getAttribute('data-base') || '';
      if (!m) { el.textContent = base; return; }
      var sfx = base.replace(/^all\s+/i, '').replace(/\s+all\s+cases?$/i, ' Cases').replace(/^phone\s+cases?$/i, 'Cases').replace(/\s*phone cases?$/i, ' Cases');
      if (!/cases?$/i.test(sfx)) sfx = sfx + ' Cases';
      el.textContent = m + ' ' + sfx.replace(/^\s+/, '');
    });
  }
  function updateCount() {
    var m = getModel();
    document.querySelectorAll('[data-bsk-ch-count]').forEach(function (el) {
      if (!el.hasAttribute('data-orig')) el.setAttribute('data-orig', el.textContent);
      if (!m) { el.textContent = el.getAttribute('data-orig'); return; }
      var n = 0;
      document.querySelectorAll('#main .product-item').forEach(function (c) { if (c.style.display !== 'none' && c.querySelector('[data-bsk-card-model]')) n++; });
      el.textContent = n + ' design' + (n === 1 ? '' : 's') + ' for ' + m + ' on this page';
    });
  }

  function injectTriggers() {
    var header = document.querySelector('store-header');
    if (!header || header.querySelector('.bsk-trigger')) return;
    var btnHtml = '<span class="bsk-trigger__icon" aria-hidden="true"><svg width="14" height="18" viewBox="0 0 14 18" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="1" y="1" width="12" height="16" rx="2.5"/><path d="M5.5 14.5h3"/></svg></span><span class="bsk-trigger__label" data-bsk-trigger-label></span><svg class="bsk-trigger__caret" width="10" height="6" viewBox="0 0 10 6"><path d="M0 0h10L5 6z" fill="currentColor"/></svg>';
    var desk = document.createElement('button');
    desk.type = 'button';
    desk.className = 'bsk-trigger bsk-trigger--desk';
    desk.setAttribute('data-bsk-open', 'full');
    desk.innerHTML = btnHtml;
    var secondary = header.querySelector('.header__secondary-links');
    if (secondary) secondary.insertBefore(desk, secondary.firstChild);
    var mob = document.createElement('div');
    mob.className = 'bsk-trigger-bar';
    mob.innerHTML = '<button type="button" class="bsk-trigger bsk-trigger--mob" data-bsk-open="full">' + btnHtml + '</button>';
    var container = header.querySelector('.container');
    if (container) container.appendChild(mob);
    updateTriggers();
  }

  /* ---------- Product page ---------- */
  function caseTypeSwatches() {
    var out = [];
    document.querySelectorAll('.product-form__variants .block-swatch').forEach(function (sw) {
      var lab = sw.querySelector('label, a');
      var letter = lab && (window.BSK_TYPES || {})[norm(lab.textContent)];
      if (letter) out.push({ el: sw, letter: letter, input: sw.querySelector('input'), label: lab });
    });
    return out;
  }

  function productList(el) {
    var list = el.getAttribute('data-list') || 'full';
    if (list === 'full' && !caseTypeSwatches().length) {
      var t = document.querySelector('.product-meta__title');
      if (t && /glass/i.test(t.textContent)) list = 'glass';
    }
    return list;
  }

  function syncCaseTypes() {
    var sw = caseTypeSwatches();
    if (!sw.length) return;
    var m = getModel();
    var ok = m ? types(m) : '';
    var restrict = !!(m && ok);
    var firstVisible = null, checkedHidden = false;
    sw.forEach(function (s) {
      var show = !restrict || ok.indexOf(s.letter) > -1;
      s.el.style.display = show ? '' : 'none';
      if (show && !firstVisible) firstVisible = s;
      if (!show && s.input && s.input.checked) checkedHidden = true;
    });
    if (checkedHidden && firstVisible && firstVisible.label) firstVisible.label.click();
  }

  var airSynced = false;
  function syncAirpods(force) {
    if (airSynced && !force) return;
    var target = AMAP[norm(getAir())];
    if (!target) return;
    var sws = document.querySelectorAll('.product-form__variants .block-swatch');
    for (var i = 0; i < sws.length; i++) {
      var lab = sws[i].querySelector('label, a');
      if (lab && norm(lab.textContent) === target) {
        var inp = sws[i].querySelector('input');
        airSynced = true;
        if (!inp || !inp.checked) lab.click();
        return;
      }
    }
  }

  function applyToProduct(el, model, soft) {
    var list = productList(el);
    var match = inList(list, model);
    var input = el.querySelector('input[type="hidden"]');
    var label = el.querySelector('[data-bsk-pdp-label]');
    var warn = el.querySelector('[data-bsk-pdp-warn]');
    if (match) {
      el.setAttribute('data-value', match);
      input.value = match;
      label.textContent = match;
      el.classList.add('has-value');
      warn.hidden = true;
      el.classList.remove('has-error');
    } else if (!soft) {
      el.setAttribute('data-value', '');
      input.value = '';
      label.textContent = 'Select your phone model';
      el.classList.remove('has-value');
    } else if (model) {
      el.setAttribute('data-value', '');
      input.value = '';
      label.textContent = 'Select your phone model';
      el.classList.remove('has-value');
      warn.textContent = 'This design isn’t available for ' + model + '. Pick another model or browse other cases.';
      warn.hidden = false;
    }
  }

  function initProductPickers() {
    var saved = getModel();
    document.querySelectorAll('[data-bsk-pdp]').forEach(function (el) {
      if (el.__bsk) return;
      el.__bsk = true;
      applyToProduct(el, saved, true);
      el.querySelector('[data-bsk-pdp-open]').addEventListener('click', function () {
        open(productList(el), el);
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.id) return;
    var pickers = document.querySelectorAll('[data-bsk-pdp][data-form="' + form.id + '"]');
    for (var i = 0; i < pickers.length; i++) {
      var p = pickers[i];
      if (!p.querySelector('input[type="hidden"]').value) {
        e.preventDefault();
        e.stopImmediatePropagation();
        p.classList.add('has-error');
        p.scrollIntoView({ behavior: 'smooth', block: 'center' });
        open(productList(p), p);
        return;
      }
    }
  }, true);

  /* ---------- Grids: only show designs made for the chosen phone ---------- */
  function filterGrid() {
    var m = getModel();
    var known = m && types(m);
    document.querySelectorAll('[data-bsk-card-model]').forEach(function (el) {
      var list = el.getAttribute('data-list') || 'full';
      var fitModel = m && inList(list, m);
      var label = fitModel || 'Phone';
      if (el.textContent !== label) el.textContent = label;
      var card = el.closest('.product-item');
      if (!card) return;
      var want = (known && !fitModel) ? 'none' : '';
      if (card.style.display !== want) card.style.display = want;
    });
    updateCount();
  }

  function boot() {
    drawer = document.getElementById('bsk-picker');
    if (!drawer) return;
    listEl = drawer.querySelector('[data-bsk-list]');
    searchEl = drawer.querySelector('[data-bsk-search]');
    noteEl = drawer.querySelector('[data-bsk-note]');
    searchEl.addEventListener('input', function () { filter(searchEl.value); });
    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-model]');
      if (b) choose(b.getAttribute('data-model'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-bsk-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-bsk-open]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-bsk-open') || 'full', null); }
      var link = e.target.closest('[data-bsk-set-model]');
      if (link) { setModel(link.getAttribute('data-bsk-set-model')); }
    });
    injectTriggers();
    initProductPickers();
    filterGrid();
    syncCaseTypes();
    if (isAirCtx()) syncAirpods(false);
    var busy = false;
    var mo = new MutationObserver(function () {
      if (busy) return;
      busy = true;
      requestAnimationFrame(function () { initProductPickers(); filterGrid(); injectTriggers(); syncCaseTypes(); busy = false; });
    });
    mo.observe(document.getElementById('main') || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.BSKModel = { get: getModel, set: function (m) { setModel(m); updateTriggers(); filterGrid(); syncCaseTypes(); }, open: open, types: types, fit: inList };
})();
